module.exports = __webpack_public_path__ + "static/img/pt.bed9a8ff.png";